var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 0L24.7148 14.1652H39.9722L27.6287 22.9197L32.3435 37.0848L20 28.3303L7.65651 37.0848L12.3713 22.9197L0.027813 14.1652H15.2852L20 0Z","fill":"#DC188E"}));
}

StarInline.defaultProps = {"width":"40","height":"38","viewBox":"0 0 40 38","fill":"none"};

module.exports = StarInline;

StarInline.default = StarInline;
